import Udesk from 'Udesk';
import React, { FC, memo, useCallback } from 'react';
import RandomFieldSelect, { typeList_common } from 'src/components/common/RandomFieldSelect';
import styled from 'styled-components';
import { FieldFoundResponse } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

const Wrapper = styled.div`
    width: 408px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: wrap;
`;

interface TemplateProps {
    dataSourceList?: number[];
    value?: (FieldFoundResponse | undefined)[];
    onChange?: (value: TemplateProps['value']) => void;
    typeList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { dataSourceList, value, onChange, typeList } = props;

    const onValueChange = (_value?: FieldFoundResponse) => {
        const newValue = dataSourceList?.map((s) => {
            if (s === _value?.inspectDataSourceType) {
                return _value;
            }
            return value?.find((v) => v?.inspectDataSourceType === s);
        });
        onChange?.(newValue);
    };

    const getPlaceholder = useCallback(
        (source) => {
            if (typeList?.length === 1) {
                if (typeList[0] === 1) {
                    return (
                        /* 请选择 */ UdeskLocales['current'].pages.semanticIntelligence
                            .externalInterface.detail.components.paramsList.components.valueSpecial1
                            .components.randomFieldSelectList.index.pleaseSelect +
                        Udesk.enums.inspectDataSources.getName(source) +
                        /* 随路字段 */ UdeskLocales['current'].pages.semanticIntelligence
                            .externalInterface.detail.components.paramsList.components.valueSpecial1
                            .components.randomFieldSelectList.index.followthepathField
                    );
                }

                if (typeList[0] === 3) {
                    return (
                        /* 请选择 */ UdeskLocales['current'].pages.semanticIntelligence
                            .externalInterface.detail.components.paramsList.components.valueSpecial1
                            .components.randomFieldSelectList.index.pleaseSelect +
                        Udesk.enums.inspectDataSources.getName(source) +
                        /* 预处理字段 */ UdeskLocales['current'].pages.semanticIntelligence.aiAgent
                            .detail.components.paramsList.components.value.components
                            .randomFieldSelectList.index.preprocessedField
                    );
                }
            } else {
                return /* 请选择 */ UdeskLocales['current'].pages.semanticIntelligence
                    .externalInterface.detail.components.paramsList.components.valueSpecial1
                    .components.randomFieldSelectList.index.pleaseSelect;
            }
        },
        [typeList]
    );

    return (
        <Wrapper>
            {dataSourceList?.map((source) => {
                const _value = value?.find((v) => v?.inspectDataSourceType === source);

                return (
                    <RandomFieldSelect
                        key={source}
                        value={_value}
                        onChange={(v) =>
                            onValueChange({
                                ...v,
                                inspectDataSourceType: source,
                            })
                        }
                        sourceList={source}
                        typeList={typeList || typeList_common}
                        style={{ width: 200 }}
                        placeholder={getPlaceholder(source)}
                        allowClear
                    />
                );
            })}
        </Wrapper>
    );
});

export default Template;
